const defaultProperties = {
  backgroundColor: '#FFFFFF',
  backgroundImage: '',
  useBackgroundMobile: false,
  backgroundImageMobile: '',
  textColor: '#000000',
  topPadding: true,
  bottomPadding: true,
  id: 'card-container-unique-id',
  dataId: 'unique-id',
  enableContainerPage: false,
  overlayColor: '#000000',
  overlayOpacity: 0,
  showOverlay: false,
};
export default (contentHtml, style = '', properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  return `
    ${style ? `<style>${style}</style>` : ''}
    <div
      data-attribute="card-container"
      id="${finalProperties.id}"
      data-id="${finalProperties.dataId}"
      data-show-overlay="${finalProperties.showOverlay}"
      data-background="${finalProperties.backgroundColor}"
      data-overlay-color="${finalProperties.overlayColor}"
      data-overlay-opacity="${finalProperties.overlayOpacity}"
      data-top-padding="${finalProperties.topPadding}"
      data-bottom-padding="${finalProperties.bottomPadding}"
      data-text-color="${finalProperties.textColor}"
      data-background-image="${finalProperties.backgroundImage}"
      data-use-background-mobile="${finalProperties.useBackgroundMobile}"
      data-background-image-mobile="${finalProperties.backgroundImageMobile}"
      style="background-color: ${finalProperties.backgroundColor}; color: ${finalProperties.textColor}; --text-color: ${
    finalProperties.textColor
  }; --overlay-color: ${finalProperties.overlayColor}; --overlay-opacity: ${finalProperties.overlayOpacity}; ${
    finalProperties.backgroundImage ? `background-image: url(${finalProperties.backgroundImage});` : ''
  }; --background-image-mobile: url(${finalProperties.backgroundImageMobile || ''})">
      <div data-attribute="overlay-bg" class="bg-overlay" style="display: ${
        finalProperties.showOverlay ? 'block' : 'none'
      };"></div>
      <div class="container-page"
        data-attribute="container-page"
        data-enable-style="${finalProperties.enableContainerPage}"
        data-background-container="#FFFFFF" style="background-color: transparent;">
          ${contentHtml}
      </div>
    </div>
  `;
};
